var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-img',{attrs:{"src":require('@/assets/logo-footer.svg'),"contain":"","max-width":"200","min-height":"78","width":"100%"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }